import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { openWhatsApp } from '../utils/whatsappHelper';

const CourseCard = ({ course }) => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  // Check if user is already enrolled in this course
  const isEnrolled = isAuthenticated && user?.enrolled_courses?.some(
    enrolledCourse => enrolledCourse.id === course.id
  );

  const handleEnroll = (e) => {
    e.stopPropagation(); // Prevent card click when clicking enroll button

    // If already enrolled, do nothing
    if (isEnrolled) {
      return;
    }

    // If user is not authenticated, redirect to login page
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    // If authenticated, open WhatsApp with course details
    const message = `Hi, I'm interested in enrolling for the promotion material`;
    openWhatsApp('919219485048', message);
  };

  const handleCardClick = () => {
    navigate(`/course/${course.id}`);
  };

  return (
    <div
      onClick={handleCardClick}
      className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
    >
      {/* Course Image */}
      <div className="h-48 sm:h-56 bg-sky-100 flex items-center justify-center overflow-hidden relative">
        {course.image ? (
          <img
            src={course.image}
            alt={course.title}
            className="w-full h-full object-contain"
          />
        ) : (
          <div className="bg-gradient-to-r from-blue-400 to-blue-600 w-full h-full flex items-center justify-center">
            <p className="text-white text-lg sm:text-xl font-semibold px-4 text-center">{course.title}</p>
          </div>
        )}

        {/* Unpublished Badge (only visible to admins) */}
        {user?.role === 'admin' && !course.is_published && (
          <div className="absolute top-2 right-2 bg-yellow-500 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg">
            DRAFT
          </div>
        )}
      </div>

      {/* Course Content */}
      <div className="p-4 sm:p-5">
        {/* Course Title */}
        <h3 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2 line-clamp-2">
          {course.title}
        </h3>

        {/* Course Description */}
        <p className="text-sm sm:text-base text-slate-600 mb-3 sm:mb-4 line-clamp-2">
          {course.description}
        </p>

        {/* Price and Enroll Button */}
        <div className="flex justify-between items-center gap-2">
          <div>
            <span className="text-blue-600 font-bold text-lg sm:text-xl">
              {course.price === 0 ? 'Free' : `₹${course.price}`}
            </span>
          </div>
          <button
            onClick={handleEnroll}
            disabled={isEnrolled}
            className={`px-3 sm:px-4 py-2 rounded transition-colors font-medium text-sm sm:text-base ${
              isEnrolled
                ? 'bg-green-100 text-green-700 cursor-not-allowed border border-green-300'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
          >
            {isEnrolled ? 'Enrolled' : isAuthenticated ? 'Enroll Now' : 'Login to Enroll'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
